








import { RouteName } from '@app/router/constants/RouteName';
import { BET_BUILDER_GROUP_ID } from '@modules/eventGrid/components/EventRow/marketGroupHelpers';
import BetSlipContainer from '@modules/sportOffer/betSlip/BetSlipContainer.vue';
import BetBuilderSummaryContainer from '@sportOfferFederation/bet-builder/bet-builder-summary/BetBuilderSummaryContainer.vue';
import MEBBSummaryContainer from '@sportOfferFederation/bet-builder/multi-event/components/MEBBSummaryContainer.vue';
import { useMEBBSummaryOddsSelections } from '@sportOfferFederation/bet-builder/multi-event/composables/useMEBBSummaryOddsSelections';
import { BetBuilderStore } from '@sportOfferFederation/bet-builder/store';
import { SportOfferMarketsStore } from '@store/modules/ui/sportOffer/markets';
import {
    useVueRouter,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
} from '@vue/composition-api';

export default defineComponent({
    name: 'UserSelectionsContainer',
    props: {
        hasStickyBetSlip: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    setup() {
        const betBuilderStore = useVuexStore<BetBuilderStore>('data/betBuilder');
        const selectionsCount = betBuilderStore.getter('selectionsCount');

        const marketsStore = useVuexStore<SportOfferMarketsStore>('ui/sportOffer/markets');
        const selectedMarketGroupId = marketsStore.state('selectedMarketGroupId');

        const isBetBuilderActive = computed(() => selectionsCount.value && selectedMarketGroupId.value === BET_BUILDER_GROUP_ID);

        const { route } = useVueRouter();
        const isMEBBPage = computed(() => route.value.name === RouteName.Sport.MultiEventBetBuilder);

        const { summaryOddsSelections } = useMEBBSummaryOddsSelections();
        const showMEBBSummary = computed(() => summaryOddsSelections.value.length && isMEBBPage.value);

        return {
            isBetBuilderActive,
            showMEBBSummary,
        };
    },
    components: {
        BetSlipContainer,
        BetBuilderSummaryContainer,
        MEBBSummaryContainer,
    },
});
